module.exports = __webpack_public_path__ + "static/quad-img-4-6fe432785981bf735aed3dbe0b11d7b2.jpg";